var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg940817(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#AF8066"
    },
    points: "140.977,164.689 52.966,203.001 0,247.139 52.966,270.179 52.966,423.691 256,511.967  459.034,423.691 458.77,423.603 459.034,422.896 459.034,269.385 512,246.345 459.034,202.207 459.034,203.001 372.259,165.307  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8C8D"
    },
    d: "M459.034,203.001l-202.417,88.011L256,291.277L52.966,203.001l88.011-38.312 c26.218,34.692,74.681,68.061,115.906,91.277c41.048-23.04,89.159-56.232,115.377-90.659L459.034,203.001z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AF8066"
    },
    points: "459.034,422.896 458.77,423.603 459.034,423.691 256,511.967 256,291.277 256.618,291.012  308.966,334.62 459.034,269.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F5B53"
    },
    points: "256,291.277 256,511.967 52.966,423.691 52.966,270.179 203.034,335.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CBB292"
    },
    points: "256,291.277 203.034,335.415 52.966,270.179 0,247.139 52.966,203.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD7AD"
    },
    points: "512,246.345 459.034,269.385 308.966,334.62 256.618,291.012 459.034,203.001  459.034,202.207  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5364"
    },
    d: "M382.499,149.947c-2.99,5.39-6.414,10.527-10.24,15.36c-26.218,34.428-74.328,67.619-115.377,90.659 c-41.225-23.217-89.688-56.585-115.906-91.277c-3.592-4.671-6.837-9.598-9.71-14.742c-31.338-53.054-31.338-106.019,0-132.59 c19.619-14.937,44.77-20.591,68.895-15.488s44.831,20.457,56.722,42.059c11.893-21.6,32.599-36.952,56.723-42.054 c24.123-5.103,49.273,0.55,68.894,15.483C413.926,43.928,413.926,96.894,382.499,149.947z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB7B76"
    },
    d: "M176.552,61.76c-2.342,0.001-4.588-0.928-6.244-2.584c-1.656-1.656-2.585-3.902-2.584-6.244v-8.828 c0-4.875,3.952-8.828,8.828-8.828s8.828,3.952,8.828,8.828v8.828c0.001,2.342-0.928,4.588-2.584,6.244 C181.139,60.831,178.893,61.761,176.552,61.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB7B76"
    },
    d: "M176.552,105.898c-2.342,0.001-4.588-0.928-6.244-2.584c-1.656-1.656-2.585-3.902-2.584-6.244 v-8.828c0-4.875,3.952-8.828,8.828-8.828s8.828,3.952,8.828,8.828v8.828c0.001,2.342-0.928,4.588-2.584,6.244 C181.139,104.969,178.893,105.899,176.552,105.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB7B76"
    },
    d: "M158.897,79.415h-8.828c-4.875,0-8.828-3.952-8.828-8.828s3.952-8.828,8.828-8.828h8.828 c4.875,0,8.828,3.952,8.828,8.828S163.772,79.415,158.897,79.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB7B76"
    },
    d: "M203.034,79.415h-8.828c-4.875,0-8.828-3.952-8.828-8.828s3.952-8.828,8.828-8.828h8.828 c4.875,0,8.828,3.952,8.828,8.828S207.91,79.415,203.034,79.415z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg940817);
export default __webpack_public_path__ + "static/media/940817.6d4a14e7aabfcaf8a8b95e822ee8197b.svg";
export { ForwardRef as ReactComponent };